import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, ValidatorFn } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-VIII',
    templateUrl: './rs005-card-VIII.component.html'
})

export class Rs005CardVIIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public filteredConfigRolos: Observable<DropDownListDTO[]>;
    public filteredTipoCalha: Observable<DropDownListDTO[]>;
    public listConfigRolos?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTipoCalha?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listConfigRolosOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listTipoCalhaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    @Output() objMakeCalculations = new EventEmitter();
    public readonlyRecobrimentosRolo?: boolean;

    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Avaliação das Despalhadoras', false);
        this.formulario = this.formBuilder.group({
            Configuracao_rolos: [null, []],
            Tipo_calha: [null, []],
            Recobrimento_rolos: [null, []],
            Numero_espigas_totais_contagem_1: [null, []],
            Numero_espigas_com_palha_contagem_1: [null, []],
            Numero_espigas_totais_contagem_2: [null, []],
            Numero_espigas_com_palha_contagem_2: [null, []],
            Despalha: [null, []],
            Espigas_palha: [null, []],
            apc_ligado: [null, []],
        });
    }

    async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    async getLists(): Promise<void> {
        await Promise.all([this.getListConfigRolos(), this.getListTipoCalha()]);
    }

    async getListConfigRolos(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'configuracao_rolos').toPromise().then(response => {
            if (!!response?.data) {
                this.listConfigRolos = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listConfigRolosOriginal = this.listConfigRolos;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorConfigRolos);
        });
    }

    async createFilterConfigRolos(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listConfigRolosOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listConfigRolos = this.listConfigRolosOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listConfigRolos = this.listConfigRolosOriginal;
            }
        } else {
            this.listConfigRolos = this.listConfigRolosOriginal;
        }
    }

    async getListTipoCalha(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'tipo_calha').toPromise().then(response => {
            if (!!response?.data) {
                this.listTipoCalha = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listTipoCalhaOriginal = this.listTipoCalha;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, '', TypeMessage.ListErrorTipoCalha);
        });
    }

    async createFilterTipoCalha(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listTipoCalhaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listTipoCalha = this.listTipoCalhaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listTipoCalha = this.listTipoCalhaOriginal;
            }
        } else {
            this.listTipoCalha = this.listTipoCalhaOriginal;
        }
    }


    warningValidatorDePalha(): boolean {
        const despalha = this.formulario.get('Despalha').value;
        return despalha > 0 && despalha < 100;
    }

}